import * as Yup from 'yup';
import { minOneWhenTrue } from '../utils';

const referringManagerContactSchema = Yup.object({
    date: Yup.string().required('error_required_field'),
    details: Yup.string().required('error_required_field'),
});

export const initialValues = {
    wasThereContactWithReferringManager: null,
    contacts: [],
};

export const validationSchema = Yup.object({
    wasThereContactWithReferringManager: Yup.boolean().required('error_required_field'),
    contacts: Yup.array().of(referringManagerContactSchema).when('wasThereContactWithReferringManager', minOneWhenTrue()),
});
